import type { PlaygameModuleOptions } from '@playgame/types'
import { useRuntimeConfig } from '#imports'

export const usePlaygameConfig = (): PlaygameModuleOptions => {
    const config = useRuntimeConfig()

    return config.public.playgame as PlaygameModuleOptions
}
